const UPFYGATE = (process.env.VUE_APP_UPFYGATE || '').trim().replace(/\/$/, '')
const AUTH_API = (process.env.VUE_APP_API_SERVER_V3 || '').trim().replace(/\/$/, '')
const MFA_BASE = UPFYGATE ? `${UPFYGATE}/auth/mfa` : (AUTH_API ? `${AUTH_API}/auth/mfa` : '')

function ensureMfaBaseConfigured () {
    if (!MFA_BASE) {
        throw new Error('MFA endpoint não configurado. Defina VUE_APP_UPFYGATE ou VUE_APP_API_SERVER_V3.')
    }
}

function unwrapResponse (resp) {
    if (resp && resp.data && resp.data.success) {
        return Promise.resolve(resp.data)
    }

    return Promise.reject((resp && resp.data) || resp)
}

function normalizeHttpError (err) {
    if (err && err.response && err.response.data) {
        return Promise.reject(err.response.data)
    }

    return Promise.reject(err)
}

function verifyOtp (sessionToken, code, rememberDevice = false) {
    ensureMfaBaseConfigured()
    return window.Vue.$httpCookiesOnly.post(
        `${MFA_BASE}/verify`,
        { code, rememberDevice },
        {
            headers: { Authorization: `Bearer ${sessionToken}` },
            // Erros desta chamada são exibidos inline pela tela MFA — suprime
            // toast genérico do interceptor global em src/main.js.
            skipGlobalErrorNotification: true
        }
    ).then(unwrapResponse).catch(normalizeHttpError)
}

function resendOtp (sessionToken, channel = null) {
    ensureMfaBaseConfigured()
    return window.Vue.$httpCookiesOnly.post(
        `${MFA_BASE}/resend`,
        // channel='email' = downgrade explícito para o canal-base (usuário sem
        // acesso ao WhatsApp). O backend ignora qualquer outro valor.
        channel ? { channel } : {},
        {
            headers: { Authorization: `Bearer ${sessionToken}` },
            // Idem verifyOtp — erros tratados inline.
            skipGlobalErrorNotification: true
        }
    ).then(unwrapResponse).catch(normalizeHttpError)
}

// Modal que pede o WhatsApp após o login. A sessão já está autenticada, então
// vai pelo cookie (sem o Bearer do pré-login). Ações usam PUT porque, no
// upfygate, POST em auth/mfa só passa pela rota pré-login de um segmento.
// Os erros são exibidos no próprio modal — suprime o toast global.
const MODAL_REQUEST_OPTIONS = { skipGlobalErrorNotification: true }

function getPhonePrompt () {
    ensureMfaBaseConfigured()
    return window.Vue.$httpCookiesOnly.get(`${MFA_BASE}/phone-prompt`, MODAL_REQUEST_OPTIONS)
        .then(unwrapResponse).catch(normalizeHttpError)
}

function markPhonePromptShown () {
    ensureMfaBaseConfigured()
    return window.Vue.$httpCookiesOnly.put(`${MFA_BASE}/phone-prompt/shown`, {}, MODAL_REQUEST_OPTIONS)
        .then(unwrapResponse).catch(normalizeHttpError)
}

function dismissPhonePrompt () {
    ensureMfaBaseConfigured()
    return window.Vue.$httpCookiesOnly.put(`${MFA_BASE}/phone-prompt/dismissal`, {}, MODAL_REQUEST_OPTIONS)
        .then(unwrapResponse).catch(normalizeHttpError)
}

function requestPhoneVerification (phone) {
    ensureMfaBaseConfigured()
    return window.Vue.$httpCookiesOnly.put(`${MFA_BASE}/phone/verification`, { phone }, MODAL_REQUEST_OPTIONS)
        .then(unwrapResponse).catch(normalizeHttpError)
}

function savePhone (phone, code) {
    ensureMfaBaseConfigured()
    return window.Vue.$httpCookiesOnly.put(`${MFA_BASE}/phone`, { phone, code }, MODAL_REQUEST_OPTIONS)
        .then(unwrapResponse).catch(normalizeHttpError)
}

// Compatibilidade com o fluxo atual em components/auth/mfaVerify.vue
const verifyMfaCode = verifyOtp
const resendMfaCode = resendOtp

export {
    verifyOtp,
    resendOtp,
    verifyMfaCode,
    resendMfaCode,
    getPhonePrompt,
    markPhonePromptShown,
    dismissPhonePrompt,
    requestPhoneVerification,
    savePhone
}
